import { Box, HStack, Text } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const ItemContainer = HStack.withConfig({
  backgroundColor: getDesignToken('background-pattern'),
  paddingY: '$3',
  paddingX: '$4',
  width: 'full',
  alignItems: 'center',
  borderTopWidth: 1,
  borderTopColor: getDesignToken('border-default'),
});

export const ItemName = Text.withConfig(({ isAvailable }: { isAvailable: boolean }) => ({
  color: isAvailable ? getDesignToken('text-default') : getDesignToken('text-disabled'),
  fontFamily: 'heading',
  marginTop: '$2',
}));

export const PictureContainer = Box.withConfig({
  height: '$17',
  width: '$19',
  alignItems: 'center',
});

export const DetailsContainer = Box.withConfig({
  flex: 1,
  marginLeft: '$4',
});

export const ItemInfoContainer = HStack.withConfig({
  backgroundColor: 'blackOpacity.5',
  paddingX: '$4',
  paddingY: '$2',
  marginTop: '$1',
});

export const InfoText = Text.withConfig({
  marginLeft: '$2',
});
